import { render, staticRenderFns } from "./WaterRecord.vue?vue&type=template&id=742900a6&scoped=true"
import script from "./WaterRecord.vue?vue&type=script&lang=js"
export * from "./WaterRecord.vue?vue&type=script&lang=js"
import style0 from "./WaterRecord.vue?vue&type=style&index=0&id=742900a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742900a6",
  null
  
)

export default component.exports